import { z } from 'zod';

// =============================================================================
// LORE SCHEMAS
// =============================================================================

/**
 * Schema for universe/world lore context.
 * Used to provide additional background for story generation.
 */
export const LoreSchema = z.object({
  universeTemplateId: z.string().optional().describe('ID of the universe template used for this story'),
  storySetting: z.string().optional().describe('A generic real-world setting for historical or cultural context (e.g., "Medieval Europe").'),
  manualLore: z.string().optional().describe('Custom lore and world-building information manually entered by the author'),
  resourceIds: z.array(z.string()).optional().describe('IDs of resources (documents, references) that provide lore context'),
  // Note: loreCharacters and loreWorldElements are complex references
  // handled separately in the Project structure
});

/**
 * Lore context for AI agents.
 * Simplified version with just the text content.
 */
export const LoreContextSchema = z.object({
  universe: z.string().optional().describe('The well-known literary or cinematic universe this story is inspired by (e.g., \'Dune\', \'Star Wars\').'),
  storySetting: z.string().optional().describe('A generic real-world setting for historical or cultural context.'),
  lore: z.string().optional().describe('Broader context or established lore for the world manually provided by the author.'),
});

// Type inference
export type Lore = z.infer<typeof LoreSchema>;
export type LoreContext = z.infer<typeof LoreContextSchema>;
